import SearchResults from "_shared/_api/search/search-results";
import MarketplaceSearchResponseSchema, { MarketplaceSearchInfoJSON } from "marketplace/_schema/marketplace-search-response-schema";

function marketplaceSearchResponseMiddlewareInternal(
  response: unknown,
  validateEnvelope: boolean,
): SearchResults<MarketplaceSearchInfoJSON> {
  const responseData = validateEnvelope
    ? (MarketplaceSearchResponseSchema.validateResponseJSON(response) as Partial<SearchResults<unknown>>)
    : (response as Partial<SearchResults<unknown>>);

  const hits = (responseData.hits ?? []).map((hit) => ({
    ...hit,
    data: MarketplaceSearchResponseSchema.validateJSON((hit as { data: unknown }).data),
  }));

  return new SearchResults<MarketplaceSearchInfoJSON>({ ...responseData, hits });
}

export function marketplaceSearchResponseMiddleware(response: unknown): SearchResults<MarketplaceSearchInfoJSON> {
  return marketplaceSearchResponseMiddlewareInternal(response, false);
}

export function marketplaceSearchResponseWithEnvelopeMiddleware(
  response: unknown,
): SearchResults<MarketplaceSearchInfoJSON> {
  return marketplaceSearchResponseMiddlewareInternal(response, true);
}
